import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../Services/HeaderService';

@Component({
    selector: 'app-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrls: ['./action-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ActionBarComponent implements OnInit {

    private subscription: Subscription[] = [];
    public data: string = '';

    headerSettings = {};
    actionBarRightList = [];
    actionBarLeftList = [];
    actionBarEnabled : Boolean = false;

    constructor(private _dataService: DataService, private _headerService : HeaderService) {
        _dataService.actionBarEnabled.subscribe(data=>{
            this.actionBarEnabled = data;
        });
        _dataService.actionBarRightList.subscribe(data=>{
            this.actionBarRightList = data;
        });
        _dataService.actionBarLeftList.subscribe(data=>{
            this.actionBarLeftList = data;
        });
        _headerService.headerSettings.subscribe(data=>{
            this.headerSettings = data;
        })
        
    }

    ngOnInit() {}
    

}


// WEBPACK FOOTER //
// ./src/app/headers/action-bar/action-bar.component.ts